
export class IdProvider {

  private static idCounter = 0;

  constructor() { }

  public static getNextId(): string {
    return `id-${IdProvider.idCounter++}`;
  }

}
